import { createPaginatedSlice } from "../../helpers/reduxHelper";

const transactionHistoryEmailList = createPaginatedSlice('transactionHistoryEmailList');

export const transactionHistoryEmailListActions = transactionHistoryEmailList.actions
export const transactionHistoryEmailListSelector = state => state.transactionHistoryEmailList;
export const transactionHistoryEmailListReducer = transactionHistoryEmailList.reducer;
export default transactionHistoryEmailListReducer

export const transactionHistoryEmailListSelectors = transactionHistoryEmailList.LF.selectors